import { apiRequest } from "../../../../shared/lib/api";
import {
  RankingUserHistoryResponse,
  RankingPeriodCode,
  Super8RankingResponse,
} from "../types/super8Ranking";

type Super8RankingFilters = {
  category?: string;
  gender?: "all" | "male" | "female";
  mode?: "all" | "super8" | "challenge" | "poco" | "tournament";
  source?: "official" | "organizer";
  organizerUserId?: number;
  period?: RankingPeriodCode;
  eventIds?: number[];
  dateFrom?: string;
  dateTo?: string;
};

function buildQuery(filters?: Super8RankingFilters) {
  const params = new URLSearchParams();
  if (!filters) return "";
  if (filters.category) params.set("category", filters.category);
  if (filters.gender) params.set("gender", filters.gender);
  if (filters.mode) params.set("mode", filters.mode);
  if (filters.source) params.set("source", filters.source);
  if (filters.period) params.set("period", filters.period);
  if (filters.dateFrom) params.set("dateFrom", filters.dateFrom);
  if (filters.dateTo) params.set("dateTo", filters.dateTo);
  if (Array.isArray(filters.eventIds)) {
    params.set(
      "eventIds",
      filters.eventIds.length > 0 ? filters.eventIds.join(",") : "__none",
    );
  }
  if (Number.isFinite(filters.organizerUserId)) {
    params.set("organizerUserId", String(filters.organizerUserId));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export function getSuper8Ranking(filters?: Super8RankingFilters) {
  return apiRequest<Super8RankingResponse>(`/api/ranking/super8${buildQuery(filters)}`);
}

export function getRankingUserHistory(
  cpf: string,
  filters?: Pick<
    Super8RankingFilters,
    "category" | "mode" | "source" | "organizerUserId"
  >,
) {
  return apiRequest<RankingUserHistoryResponse>(
    `/api/ranking/users/${encodeURIComponent(cpf)}/history${buildQuery(filters)}`,
  );
}
